import * as React from 'react';
import * as ReactDOM from 'react-dom/client';

import App from './App.jsx';

import './main.css';
import './services/i18n';

ReactDOM.createRoot(document.getElementById('root')).render(
	// <React.StrictMode> //load the game page twice and does not unload the first one, why?
	<App />,
	// </React.StrictMode>
);
